import React from 'react'

function Ternary() {
    return (
        <span className='cs-exp-ternary'>Ternary</span>

    )
}

export { Ternary }